import { render, staticRenderFns } from "./mrInput.vue?vue&type=template&id=fc1b9daa&scoped=true&lang=pug"
import script from "./mrInput.vue?vue&type=script&lang=js"
export * from "./mrInput.vue?vue&type=script&lang=js"
import style0 from "./mrInput.vue?vue&type=style&index=0&id=fc1b9daa&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1b9daa",
  null
  
)

export default component.exports